import { AfterViewInit, Directive, ElementRef, Injector, OnDestroy, OnInit } from "@angular/core";
import { FrameContext } from "@farris/devkit";
import { NavComponent } from '@farris/ui-nav';
import { ComponentRef } from "./component-ref";

@Directive({
  selector: '[navRef]'
})
export class NavComponentRefDirective extends ComponentRef implements OnInit, OnDestroy, AfterViewInit {
  constructor(private injector: Injector, private component: NavComponent, public elementRef: ElementRef, public frameContext: FrameContext) {
    super(frameContext, elementRef);
  }
  ngAfterViewInit(): void {
    this.tryAddComponent(this.component);
  }
  ngOnInit(): void {
    this.addComponent(this.component);
  }
  ngOnDestroy(): void {
  }

}